import { useAtomValue } from 'jotai';

import { ALL_AXES, type Axis } from '@core';
import { VISUALIZATION_AXES, VISUALIZATION_MEASUREMENTS } from '@elva-visualizer';
import { activeData3dAtom } from '@store';
import { Box } from '@ui';

import * as css from './SwingGuide3D.css';
import { SwingGuide3DScene } from './SwingGuide3DScene';

type GuideParameter = {
    timeSeriesId: string | null | undefined;
    axis: Axis | null | undefined;
};

type SwingGuide3DProps = {
    parameter: GuideParameter;
    frame: number;
};

export const SwingGuide3D = ({ parameter, frame }: SwingGuide3DProps) => {
    const activeData = useAtomValue(activeData3dAtom);
    const measurement = parameter.timeSeriesId ? VISUALIZATION_MEASUREMENTS[parameter.timeSeriesId] : undefined;
    const axis =
        measurement && parameter.axis
            ? VISUALIZATION_AXES[measurement.axes[ALL_AXES.indexOf(parameter.axis)]]
            : undefined;

    if (!activeData || !axis?.targetPoints[0]) return null;

    return (
        <Box height="100%" position="relative" radius="lg" className={css.root}>
            <SwingGuide3DScene swingScene={activeData} axis={axis} frame={frame} />
        </Box>
    );
};
